import {mapState} from "vuex";

const sortedProducts = {
  computed: {
    ...mapState("simulation", ["wantOnlineGreen", "onlineGreenProduct"]),
    sortedProducts() {
      let items = JSON.parse(JSON.stringify(this.items));
      if(this.wantOnlineGreen) {
        let indexToReplace = items.findIndex((item) => {
          return item.range === 'ONLINE'
        })

        let indexProductToReplace = items[indexToReplace].products.findIndex((item2) => {
          return item2.energyType === 'electricity'
        })

        items[indexToReplace].electricity = this.onlineGreenProduct
        items[indexToReplace].products[indexProductToReplace] = this.onlineGreenProduct
        return items
      }
      return this.items
    }
  }
}

export default sortedProducts;



// WEBPACK FOOTER //
// ./src/mixins/sortedProducts.js